import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_templates',
          component: Index,
          meta: {
            // Message templates belong to WhatsApp/SMS outreach, gated with campaigns
            featureFlag: FEATURE_FLAGS.CAMPAIGNS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
